import React from 'react';
import { useTranslate } from '@bynder/localization';
import { IconUserGroup } from '@bynder/icons';
import { dispatchCustomEvent } from '../../helpers/useCustomEvent';
import { iconSizeMedium } from '../../helpers/iconSizes';

export function WFGroupsMenuItemOLD() {
	const { translate } = useTranslate();

	function openModal() {
		dispatchCustomEvent('openWFGroupsModal');
	}

	return (
		<a
			href="#"
			className="admin-option-sub"
			onClick={openModal}
			data-testid="wf-group-management-menuitem"
		>
			<IconUserGroup size={iconSizeMedium} /> {translate('workflow.GroupManagement')}
		</a>
	);
}
